<template>
  <v-card class="elevation-1 mb-6 rounded-lg mt-0">
    <v-card-title class="pa-7">
      Přehled nabídek
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="orderHeadersByRole"
        :items="offer.items"
        :options.sync="offer.options"
        :server-items-length="offer.serverItemsLength"
        :loading="offer.loading"
        item-key="id"
        class="elevation-0"
      >
        <template v-slot:item.id="{ item }">
          <router-link
            :to="{
              name: 'personalized-offer.detail',
              params: {
                offerId: item.id,
              },
            }"
          >
            {{ item.id }}
          </router-link>
        </template>
        <template v-slot:item.status="{ item }">
          <OfferStatus :status="item.status" />
        </template>
        <template v-slot:item.createdAt="{ item }">
          <DateTime :single-line="false" :datetime="item.createdAt" />
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { setFilters } from '@/components/mixins/setFilters'
import DateTime from '@/components/DateTime'
import OfferStatus from '../offer/OfferStatus'

export default {
  name: 'CustomerOffers',
  components: {
    OfferStatus,
    DateTime,
  },
  mixins: [setFilters],
  props: {
    id: {
      id: Number,
      required: true,
    },
  },
  data() {
    return {
      offer: {
        headers: [
          {
            text: 'Datum',
            value: 'createdAt',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Id',
            value: 'id',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Název',
            value: 'name',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Typ',
            value: 'type.text',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: 'Stav',
            value: 'status',
            roles: ['ROLE_ADMIN'],
          },
          {
            text: '',
            value: 'actions',
            width: '1px',
            sortable: false,
            roles: ['ROLE_ADMIN'],
          },
        ],
        items: [],
        options: {
          page: 1,
          itemsPerPage: 5,
          sortBy: ['id'],
          sortDesc: [true],
        },
        loading: false,
        serverItemsLength: 0,
      },
      offerFooter: {
        totalElements: 0,
        selectedData: {
          params: {},
          items: [],
        },
      },
      cancel: null,
    }
  },
  computed: {
    ...mapState({
      authorities: (state) => state.auth.user.authorities,
    }),
    orderHeadersByRole() {
      return this.offer.headers.filter((e) => e.roles.some((e) => this.authorities.includes(e)))
    },
  },
  watch: {
    status: {
      handler() {
        this.loadOffers()
      },
    },
    'offer.options': {
      handler() {
        this.loadOffers()
      },
    },
    '$route.query': {
      handler() {
        this.loadOffers()
      },
    },
  },
  methods: {
    ...mapActions({
      searchCustomerPersonalizedOffers: 'customer/searchCustomerPersonalizedOffers',
    }),
    loadOffers() {
      this.offer.loading = true
      const searchParams = {
        options: this.offer.options,
      }
      this.searchCustomerPersonalizedOffers({ id: this.id, params: searchParams })
        .then((response) => {
          this.offerFooter.totalElements = response.data.totalElements
          this.offer.items = response.data.items
          this.offer.serverItemsLength = response.data.totalElements
          this.cancel = null
        })
        .finally(() => {
          this.offer.loading = false
        })
    },
    setFiltersAction(filters) {
      this.offer.options.page = 1
      this.setFilters(filters)
    },
  },
}
</script>
